"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAnchor = void 0;
var _react = require("@linaria/react");
const StyledAnchor = exports.StyledAnchor = /*#__PURE__*/(0, _react.styled)("a")({
  name: "StyledAnchor",
  class: "sudxhx9",
  vars: {
    "sudxhx9-0": [({
      underlined
    }) => !underlined ? 'none' : 'underline']
  }
});